enum DashboardEntryRenderFnEnum {
    ADD_BTN = "addBtn",
    ITEM_LOOKUP = "itemLookup",
    DESCRIPTION = "description",
    QTY = "qty",
    PRICE_PER_UNIT = "pricePerUnit",
    TOTAL = "total",
    MSRP = "msrp",
    ITEM_NO = "itemNo",
    SKU = "sku",
}

export default DashboardEntryRenderFnEnum;
